import { httpPost } from "@/services/api.service";
import { ENDPOINT_CLICK_STREAM } from "@/common/constants/api";
import { getOrganizationGroup } from "@/common/storage";

export { _saveClickStreamEvent as saveClickStreamEvent };

const _saveClickStreamEvent = async (params) => {
  try {
    if (params) {
      let user_group = getOrganizationGroup();
      if (user_group && user_group.name) {
        params.user_group = user_group.name;
      }

      const INPUT_STRING = JSON.stringify(params);

      const RESULT = await httpPost({
        url: ENDPOINT_CLICK_STREAM,
        data: JSON.parse(INPUT_STRING),
      });

      if (RESULT) {
        return true;
      }
      return null;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Issue save click stream event", error);
    return null;
  }
};
